import { useCallback } from "react";

/**
 * Die Kennung eines Objekts als Attribut am `me-objekt` (Sprungfokus, Rollposition, Fokus-Ersatz) — die Hülle reicht keine
 * `data-*` durch (Wunsch W-12). Lieferverträge, Eingangsrechnungen und Liquiditätspositionen nutzen denselben Weg.
 */
export function useKennungsAttribut(name: string, id: string): (el: HTMLElement | null) => void {
  return useCallback((el: HTMLElement | null) => { el?.setAttribute(name, id); }, [name, id]);
}
